<template>
  <div
    :grc_text="buttontext"
    :grc_width="buttonwidth"
    :grc_readonly="readonly"    
    :grc_color="buttoncolor"
    :grc_shadow="buttonshadow"
    :grc_buttonpos="buttonpos"
    :grc_radius="radius"
    :grc_padding="padding"
    :grc_textalign="textalign"
    :grc_fontsize="fontsize"
    :grc_lefticon="lefticon"
    :grc_righticon="righticon"

      v-bind:style="{ 'width':buttonwidth, 'display':'inline-block' }"    

  >
    <button ref="button"
        :class="['grc-button line', readonly=='true' ? 'grc-button-readonly' : '',
        buttoncolor=='blue' ? 'color10' : '',
        buttoncolor=='grey' ? 'color9' : '',
        buttoncolor=='grey-menu' ? 'grc-button-grey-menu' : '',
        buttoncolor=='green' ? 'color1' : '',
        buttoncolor=='yellow' ? 'color4' : '',
        buttoncolor=='red' ? 'color8' : '',
        buttonshadow=='true' ? 'grc-button-shadow' : ''
        ]"


        v-bind:style="{ 'border-top-left-radius': radius1, 'border-bottom-left-radius': radius2, 
        'border-top-right-radius': radius3, 'border-bottom-right-radius': radius4
         }"    

        @click="ButtonClick"
        @keydown="onInputKeydown"
    >
      <span style="height:33px; width:calc(100% - 6px); line-height:15px; line-height: 15px; padding-left: 0px !important;">
        <table style="width:100%; margin-top:1px;" cellspacing="0" cellpadding="0">
            <tr style="height: 100%;">
                <td style="width:1px;" v-html="lefticon"></td>
                <td v-bind:style="{'padding': padding, 'text-align':textalign, 'font-size': fontsize, 'line-height': fontsize}">
                    {{buttontext}}
                </td>
                <td style="width:1px;" v-html="righticon"></td>
            </tr>
        </table>
      </span>  
        
    </button>

  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'GrcButton',
  components:
  {

  },
  props: {
    grc_text: String,
    grc_width: String,
    grc_readonly: String,
    grc_color: String,
    grc_shadow: String,
    grc_buttonpos: String,
    grc_radius: String,
    grc_padding: String,
    grc_textalign: String,
    grc_fontsize: String,
    grc_lefticon: String,
    grc_righticon: String
  },
  data () {
    return {
        buttontext: this.grc_text,
        buttonwidth: this.grc_width,
        readonly: this.grc_readonly,
        buttoncolor: this.grc_color,
        buttonshadow: this.grc_shadow,
        buttonpos: this.grc_buttonpos,
        radius: this.grc_radius,
        padding: this.grc_padding,
        textalign: this.grc_textalign,
        fontsize: this.grc_fontsize,
        lefticon: this.grc_lefticon,
        righticon: this.grc_righticon,

        radius1: "",
        radius2: "",
        radius3: "",
        radius4: "",

        comp_focused: false
    }
  },
  watch : {
  },

  created: function()
  {
    if (typeof this.buttontext == "undefined")
    {
      this.buttontext = "";
    }

    if (typeof this.buttonwidth == "undefined")
    {
      this.buttonwidth = "100%";
    }

    if (typeof this.padding == "undefined")
    {
      this.padding = "8px 8px";
    }

    if (typeof this.textalign == "undefined")
    {
      this.textalign = "center";
    }

    if (typeof this.fontsize == "undefined")
    {
      this.fontsize = "";
    }

    if (typeof this.lefticon == "undefined")
    {
      this.lefticon = "";
    }

    if (typeof this.righticon == "undefined")
    {
      this.righticon = "";
    }

    if (typeof this.buttonpos == "undefined")
    {
      this.buttonpos = "single";
    }

    if (typeof this.radius == "undefined")
    {
        this.radius = "2px";
    }

    this.radius1 = this.radius;
    this.radius2 = this.radius;
    this.radius3 = this.radius;
    this.radius4 = this.radius;

    if (this.buttonpos == "first")
    {
        this.radius3 = "0px";
        this.radius4 = "0px";
    }

    if (this.buttonpos == "last")
    {
        this.radius1 = "0px";
        this.radius2 = "0px";
    }

    if (this.buttonpos == "middle")
    {
        this.radius1 = "0px";
        this.radius2 = "0px";
        this.radius3 = "0px";
        this.radius4 = "0px";
    }


  },
  computed: {
  },
  methods: {

    SetLabel(pText)
    {
      this.buttontext = pText;
    },

    ButtonClick()
    {
        if (this.IsReadonly()) { return; }
        else {
            
            this.$emit('grc-click');
        }
    },


    onInputKeydown(e)
    {
      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.ButtonClick();
      }
    },

    SetFocus()
    {
      this.$refs.button.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    }



    
  }
}
</script>

<style scoped>

</style>